import { useContext, useEffect, useState } from "react";
import axios from "axios";
import AppContext from "../../utils/AppContext";
import { api, setAccessTokens } from "../../utils/api";

import PasswordInput from '../../common/PasswordInput/PasswordInput';
import { Trans as T } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { ReactComponent as ErrorIcon } from "../../assets/icons_svg/error-lined.svg";
import './ChangeEmailPasswordModal.scss';

export default function ChangePasswordModal({ show, onHide }) {
  const [state, dispatch] = useContext(AppContext);
  const { currentUser } = state;

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errors, setErrors] = useState(null);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (show) {
      setOldPassword('');
      setNewPassword('');
      setErrors(null);
      setValidated(false);
    }
  }, [show]);

    const changePassword = async e => {
    e.preventDefault();
    setErrors(null);
    
    try {
      await api.post('/change-password/', {
        old_password: oldPassword,
        new_password: newPassword,
      });

      // NOTE: Auth tokens use Form URL Encoded, NOT JSON as a body (see the Bruno request). JSON will not work:
      const params = new URLSearchParams();
      params.append('client_id', process.env.REACT_APP_API_CLIENT_ID);
      params.append('username', currentUser.email);
      params.append('password', newPassword);
      params.append('grant_type', 'password');

      const { data: loginData } = await axios.post(process.env.REACT_APP_API_URL + '/auth/token/', params);

      setAccessTokens(loginData.access_token, loginData.reset_token);
      dispatch({ type: 'globalToast/set', payload: { message: "Password successfully changed" }});

      onHide();
    }
    catch (error) {
      setErrors(error.response.data);
      setValidated(true);
    }
  }
  
  return (
    <Modal className='__modal __change-email-password-modal' size='md' show={show} onHide={onHide} centered>
      <Modal.Header closeButton><h2><T>Change Password</T></h2></Modal.Header>
      <Form noValidate validated={validated && !errors} onSubmit={changePassword}>
        <Modal.Body>
          <div className="change-warning">
            <ErrorIcon />
            <div>
              <p><strong><T>Your old password will no longer work</T></strong></p>
              <p><T i18nKey='verify-email-access'>Verify you can access <strong>{{ email: currentUser.email }}</strong> so you do not lose access to your account</T></p>
            </div>
          </div>

          <Form.Group className="field-group">
            <Form.Label><T>Enter your old password</T></Form.Label>
            <PasswordInput autoFocus value={oldPassword} onChange={e => setOldPassword(e.target.value)} isInvalid={errors?.old_password} isValid={validated && !errors?.old_password} feedback={ errors?.old_password?.map(error => <Form.Control.Feedback type="invalid" key={error}><T>{ error }</T></Form.Control.Feedback>) } />
          </Form.Group>

          <Form.Group className="field-group">
            <Form.Label className=""><T>Enter your new password</T></Form.Label>
            <PasswordInput value={newPassword} onChange={e => setNewPassword(e.target.value)} isInvalid={errors?.new_password} isValid={validated && !errors?.new_password} feedback={ errors?.new_password?.map(error => <Form.Control.Feedback type="invalid" key={error}><T>{ error }</T></Form.Control.Feedback>) } />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button type='button' className='cancel' onClick={onHide}><T>Close</T></Button>
          <Button className="confirm" type="submit" disabled={!oldPassword.trim() || !newPassword.trim()}><T>Confirm</T></Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
